import type {ReactNode, Ref} from 'react';
import classNames from 'classnames';

import {useTooltip} from '../../../hooks/tooltip';
import {PaperclipAttachmentIcon} from '../../../icons/paperclip-attachment';

import {Tooltip} from '../../../atoms/tooltip';
import {trimFilename} from '../../../utils/attachments/utils';

import {OVERLAY_TIME_DELAY_LONG} from './constants';

import styles from './styles.module.css';

type Props = {
    fileInfo: {
        name: string;
        id: string;
    };
    getDownloadUrl: (id: string) => string;
    tooltipText: string;
    compactDisplay?: boolean;
    children?: ReactNode;
    onClick?: () => void;
};

export const FilenameOverlay = ({
    fileInfo,
    tooltipText,
    getDownloadUrl,
    children,
    compactDisplay,
    onClick,
}: Props) => {
    const fileName = fileInfo.name;
    const trimmedFilename = trimFilename(fileName);

    const {triggerRef, triggerProps, tooltipProps, tooltipState} = useTooltip(OVERLAY_TIME_DELAY_LONG);

    return (
        <div
            className={classNames({
                [styles.overlay]: !compactDisplay,
                [styles.compactOverlay]: compactDisplay,
            })}
        >
            <a
                ref={triggerRef as Ref<HTMLAnchorElement>}
                {...triggerProps}
                href={getDownloadUrl(fileInfo.id)}
                rel='noopener noreferrer'
                aria-label={tooltipText.toLowerCase()}
                download={fileName}
                target='_blank'
                className={styles.downloadButton}
                onClick={(event) => {
                    event.stopPropagation();
                    triggerProps.onClick?.(event);
                    onClick?.();
                }}
            >
                {compactDisplay && (
                    <span className={styles.attachmentIconWrapper}>
                        <PaperclipAttachmentIcon />
                    </span>
                )}
                {compactDisplay && trimmedFilename}
                {!compactDisplay && (children || trimmedFilename)}
            </a>
            {tooltipState.isOpen && (
                <Tooltip targetRef={triggerRef} state={tooltipState} {...tooltipProps}>
                    {compactDisplay ? fileName : tooltipText}
                </Tooltip>
            )}
        </div>
    );
};
